"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_zoom_pan_pinch_1 = require("react-zoom-pan-pinch");
const icons_1 = require("../../assets/icons");
const rootNavigation_1 = require("../../navigators/rootNavigation");
const scale_1 = require("../../utils/scale");
const images_1 = require("../../assets/images");
const ImageViewerScreen = (props) => {
    const { uri } = props.route.params;
    const { width: _width, height } = react_native_1.Dimensions.get('window');
    const width = react_native_1.Platform.OS === 'web' ? (_width >= 1024 ? 375 : _width) : _width;
    return (react_1.default.createElement(react_native_1.View, { style: { flex: 1 } },
        react_1.default.createElement(react_native_1.ImageBackground, { source: images_1.images?.BackGroundPng, style: {
                backgroundColor: '#000',
                position: 'relative',
                width: width,
                height: '100%'
            } },
            react_1.default.createElement(react_zoom_pan_pinch_1.TransformWrapper, { smooth: true },
                react_1.default.createElement(react_zoom_pan_pinch_1.TransformComponent, null,
                    react_1.default.createElement(react_native_1.Image, { source: { uri }, style: { width, height }, resizeMode: "contain" }))),
            react_1.default.createElement(react_native_1.View, { style: styles.header },
                react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: rootNavigation_1.goBack },
                    react_1.default.createElement(icons_1.IC_X, { width: (0, scale_1.scale)(24), height: (0, scale_1.scale)(24), color: "#000" }))))));
};
exports.default = ImageViewerScreen;
const styles = react_native_1.StyleSheet.create({
    header: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        flexDirection: 'row',
        padding: (0, scale_1.scale)(16),
        zIndex: 1
    }
});
